<template>
  <component
    v-bind:is="component"
    v-bind="$attrs"
    :label="label"
    :items="items"
    :value="value"
    :search-input.sync="search"
    :loading="loading"
    :disabled="disabled"
    :hide-details="hideDetails || dense"
    :class="fieldClasses"
    :no-data-text="noDataText"
    :hide-no-data="loading"
    :chips="chips"
    :hide-selected="chips && hideSelected"
    autocomplete="off"
    :allow-overflow="false"
    :menu-props="{ maxHeight: 250 }"
    deletable-chips
    open-on-clear
    item-value="id"
    :item-text="itemText"
    :no-filter="noFilter"
    eager
    @input="handleInput"
    @focus="handleFocus"
    @blur="handleBlur"
    @change="handleChange"
  >
    <template v-if="chips" v-slot:selection="data">
      <v-chip
        :input-value="data.selected"
        close
        class="select_chip"
        @click:close="remove(data.item)"
      >
        <span class="select_chip_span">
          {{ data.item.name }}
        </span>
      </v-chip>
    </template>
  </component>
</template>

<script>
import Catalogs from '@/api/http/catalogs';
import { VAutocomplete, VSelect } from 'vuetify/lib';

import BaseLoading from '@/components/base/BaseLoading.vue';

import ServerSelectField from '@/mixins/fields/server-select-field';
import CustomField from '@/mixins/fields/custom-field';

export default {
  props: {
    searchable: {
      type: Boolean,
    },
    slug: {
      type: String,
    },
    hideSelected: {
      type: Boolean,
      default: true,
    },
    noFilter: {
      type: Boolean,
      default: false,
    },
    chips: {
      type: Boolean,
    },
  },
  computed: {
    component() {
      if (this.searchable) {
        return VAutocomplete;
      }

      return VSelect;
    },
  },
  methods: {
    fetchItems(params = {}) {
      const paramsToSend = { ...params };

      if (this.slug === 'offices') {
        paramsToSend.perPage = 10000;
      }

      return Catalogs.list(this.slug, paramsToSend);
    },
    remove(item) {
      let index = -1;
      if (this.returnObject) {
        index = this.value.findIndex(value => value[this.itemValue] === item[this.itemValue]);
      } else {
        index = this.value.indexOf(item[this.itemValue]);
      }
      if (index >= 0) {
        this.value.splice(index, 1);
        this.$emit('input', this.value);
      }
    },
    itemText({ name, name_en: nameEn }) {
      return this.$i18n.locale === 'en' ? nameEn || name : name;
    },
  },
  mixins: [ServerSelectField, CustomField],
  components: {
    BaseLoading,
  },
};
</script>

<style lang="scss">
.select_chip {
  .select_chip_span {
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
